namespace $.$$ {

	$mol_style_define( $shm_hitalama_map_overlayed, {

		position: 'fixed',
		inset: '0',
		zIndex: 2,
		background: {
			color: 'transparent',
		},
		pointerEvents: 'none',

		Pane: {
			pointerEvents: 'none',

			Back: {
				pointerEvents: 'none',
				outline: 'none',
			},

			Content: {
				pointerEvents: 'auto',
			},
		},

		Context_menu: {
			pointerEvents: 'auto',
		},

	} )

}
